module.exports = "pegasus/assets/blocks/column-13-theme2.png";